export let text_app = {
  title_app_bar: {
    th: "ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา",
    en:
      "The Royal Institute of Thailand's Transliterated Words Database System",
  },
  footer_office: {
    th: "ติดต่อ สำนักงานราชบัณฑิตยสภา",
    en: "Contact The Office of The Royal Society",
  },
  footer_phone_title: {
    th: "โทรศัพท์ : ",
    en: "Phone: ",
  },
  footer_phone_detail: {
    th: "๐ ๒๓๕๖ ๐๔๖๖-๗๐", // ต่อ ๑๐๐๘,๑๐๑๐
    en: "0 2356 0466-70", // Ext. 1008,1010
  },
  footer_email_title: {
    th: "อีเมล : ",
    en: "Email: ",
  },
  footer_email_detail: {
    th: " transliteration@orst.go.th",
    en: " transliteration@orst.go.th",
  },
  zoom: {
    th: "ขยาย",
    en: "zoom",
  },
  zoom_in_out: {
    th: "ย่อ / ขยาย",
    en: "Zoom In / Zoom Out",
  },
  language_th_en: {
    th: "TH",
    en: "EN",
  },
};
export let text_searchHomePage = {
  transliteration_search: {
    th: "ค้นหาคำทับศัพท์",
    en: "Transliterated words search",
  },
  search_placeholder: {
    th: "ระบุคำทับศัพท์",
    en: "Type word or phase",
  },
  all_language: {
    th: "ทุกภาษา",
    en: "All",
  },
  all_language_title: {
    th: "ภาษาทั้งหมด : ",
    en: "All Language : ",
  },
  // found word
  search_result: {
    th: "ผลการค้นหาคำทับศัพท์",
    en: "Results",
  },
  // not found
  word_not_found_title: {
    th: "ไม่พบผลลัพธ์การค้นหาคำศัพท์",
    en: "No result found ! ",
  },
  word_not_found_sub_title: {
    th: "โปรดตรวจสอบตัวอักษรที่คุณต้องการค้นหาอีกครั้ง",
    en: "Verify again",
  },
  // found List
  found_list: {
    th: "ผลการค้นหา",
    en: "Search results",
  },
  found_nearby_word: {
    th: "พบคำใกล้เคียง",
    en: "Found nearby words",
  },
  list_unit: {
    th: "รายการ",
    en: "lists",
  },
  // ===========================================================
  // CardWordDetail
  transcription: {
    th: "คำทับศัพท์ : ",
    en: "Transliteration : ",
  },
  updated_on:{
    th:"แก้ไขล่าสุดเมื่อ : ",
    en:"Updated on : "
  },
  category: {
    th: "หมวดหมู่",
    en: "Category",
  },
  sub_language_not_found: {
    th: "ไม่พบข้อมูล",
    en: "NOT FOUND",
  },
  // ===========================================================
  // CardRequestWord
  translation_chanel: {
    th: "ช่องทางเสนอคำทับศัพท์เพิ่มเติม",
    en: "New word suggesttion",
  },
  vocabulary: {
    th: "คำศัพท์",
    en: "Word",
  },
  vocabulary_placeholder: {
    th: "ระบุคำศัพท์",
    en: "Type word or pharse",
  },
  language: {
    th: "ภาษา",
    en: "Lanuage",
  },
  language_placeholder: {
    th: "ระบุภาษา เช่น ภาษาญี่ปุ่น",
    en: "Such  as Japanes",
  },
  more_info: {
    th: "ข้อมูลเพิ่มเติม",
    en: "More info",
  },
  more_info_placeholder: {
    th: "อธิบายความหมายของคำทับศัพท์",
    en: "Please provide informations of the suggested word.",
  },
  email: {
    th: "กรอกอีเมลของคุณ",
    en: "Enter your email",
  },
  email_placeholder: {
    th: "winai@gmail.com",
    en: "winai@gmail.com",
  },
  defualt_text: {
    th:
      "*** เราจะนำข้อมูลข้อเสนอแนะของคุณไปพิจารณา และตอบกลับมาทางอีเมลของคุณอีกครั้ง",
    en:
      "*** We will take your feedback into consideration. And reply via your email again !!",
  },
  submit_btn: {
    th: "ส่งข้อมูล",
    en: "Send",
  },
  // ===========================================================
  // CardFeedback
  satisfaction_form_title: {
    th: "แบบประเมินความพึงพอใจ",
    en: "Customer Satisfaction Survey Form",
  },
  satisfaction_form_detail: {
    th: "คุณมีความพึงพอใจ ในการใช้งานระบบคำทับศัพท์มากน้อยเพียงใด",
    en:
      "Please tell us how much you are satisfied in the Transliterated Words Database System",
  },
  satisfaction_form_detail_mobile_line1: {
    th: "คุณมีความพึงพอใจ ในการใช้งาน",
    en: "Please tell us how much you are satisfied",
  },
  satisfaction_form_detail_mobile_line2: {
    th: "ระบบคำทับศัพท์มากน้อยเพียงใด",
    en: "in the Transliterated Words Database System",
  },
  satisfaction_form_score_unit: {
    th: "คะแนน",
    en: "Score",
  },
  satisfaction_explain: {
    th:
      "แบบประเมินนี้สำรวจความพึงพอใจของผู้ใช้บริการต่อเว็บไซต์ เพื่อเป็นประโยชน์ในการ ปรับปรุงระบบในครั้งถัดไปให้ดีขึ้น",
    en:
      "The results of this study will help to improve the user satistaction of the website.",
  },
  satisfaction_explain_mobile_line1: {
    th: "แบบประเมินนี้สำรวจความพึงพอใจของผู้ใช้บริการต่อเว็บไซต์",
    en: "The results of this study will help to improve the user",
  },
  satisfaction_explain_mobile_line2: {
    th: "เพื่อเป็นประโยชน์ในการ ปรับปรุงระบบในครั้งถัดไปให้ดีขึ้น",
    en: "satistaction of the website.",
  },
  satisfaction_btn: {
    th: "แบบประเมิน",
    en: "Survey Form",
  },
  suggestion: {
    th: "ข้อเสนอแนะ",
    en: "Suggestion",
  },
  suggestion_placeholder: {
    th: "แสดงความคิดเห็นของคุณ",
    en: "Your comment",
  },
  // ===========================================================
  // Swal
  swal_invalidate_title: {
    th: "ข้อมูลไม่ครบถ้วน !",
    en: "Incomplete information. !",
  },
  swal_invalidate_text: {
    th: "กรุณากรอกข้อมูลให้สมบูรณ์",
    en: "Please complete the information.",
  },
  swal_validate_title: {
    th: "ส่งข้อมูลสำเร็จ",
    en: "Successfully",
  },
  swal_validate_text: {
    th: "ส่งข้อมูลเรียบร้อยแล้ว",
    en: "The information has been sent.",
  },
};
